import { render } from "./Webhooks.vue?vue&type=template&id=6003813e"
import script from "./Webhooks.vue?vue&type=script&lang=ts"
export * from "./Webhooks.vue?vue&type=script&lang=ts"
script.render = render

export default script